import styled from 'styled-components';

export const ImageContainer = styled.div`
  width: 100%;
  height: 200px;
  position: absolute;
  top: 0;
  left: 0;
  filter: opacity(0.5);
  display: flex;
  justify-content: center;
  align-items: center;
`;
